






































































type Prop<T> = () => T
import Vue from 'vue'
import FormValues from '@/types/form-values'

export default Vue.extend({
  props: {
    values: Object as Prop<FormValues>
  },
  methods: {
    correction() {
      this.$emit('correction', false)
    },
    submit() {
      const form = new FormData(this.$refs.form as HTMLFormElement)
      fetch('/mailcon.php', { method: 'POST', body: form })
        .then(response => response.text().then(text => ({ status: response.status, text })))
        .then(({ status, text }) => {
          if (status >= 400 || text.includes('エラー')) {
            console.error('mailcon.php error:', status, text)
            alert('送信に失敗しました。しばらく時間をおいて再度お試しください。')
            return
          }
          this.$router.push('/thanks')
        })
        .catch(error => {
          console.error('Mail send network error:', error)
          alert('送信に失敗しました。しばらく時間をおいて再度お試しください。')
        })
    }
  }
})
